// src/components/branding/Logo.jsx

import React from 'react';
import { BRAND_CONFIG } from '../../config/brand';

const Logo = ({ size = 48, className = "" }) => {
    return (
        <svg 
            viewBox={BRAND_CONFIG.logo.viewBox}
            height={size} 
            width={size * 1.08} // Maintaining aspect ratio from original file
            className={className} 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                fill="currentColor" // Allows Tailwind classes (text-white, text-blue-500) to control color
                d={BRAND_CONFIG.logo.path}
            />
        </svg>
    );
};

export default Logo;